import React from 'react';

import { Link, Tooltip } from '@material-ui/core';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import useStyles from './style';

dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const TooltipCellFormatter = ({
  value,
  tooltipMaxStrLength = 50,
}: {
  value: string;
  tooltipMaxStrLength: number | undefined;
}) => {
  const classes = useStyles();

  if (value.length >= tooltipMaxStrLength) {
    const trucatedValue = `${value.substr(0, tooltipMaxStrLength)}...`;

    return (
      <Tooltip
        classes={{ tooltip: classes.tooltipCenterContent }}
        title={<span className={classes.tooltipLabel}>{value}</span>}
      >
        <span>{trucatedValue}</span>
      </Tooltip>
    );
  }

  return value;
};

export const StatusCellFormatter = ({
  status,
  iconMap,
}: {
  status: string;
  iconMap: { default: JSX.Element; [key: string]: JSX.Element };
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={<span className={classes.tooltipLabel}>{status}</span>}>
      {iconMap[status] || iconMap.default}
    </Tooltip>
  );
};

export const DateCellFormatter = ({
  value,
  format,
}: {
  value: string;
  format: string;
}) => {
  if (dayjs(value, format).isValid()) {
    return dayjs(value).local().format(format);
  }

  return null;
};

export const DurationCellFormatter = ({ value }: { value: number }) => {
  const hours = parseInt(`${value}`, 10);
  const minutes = Math.ceil((value - hours) * 60);
  const formatedHours = hours < 10 ? `0${hours}` : hours;
  const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formatedHours}:${formatedMinutes}`;
};

export const ExternalLinkCellFormatter = ({ value }: { value: string }) => {
  return (
    <Link target="_blank" rel="noopener noreferrer" href={value}>
      {value}
    </Link>
  );
};

export const TextOptionsCellFormatter = ({
  value,
  textMap,
}: {
  value: string;
  textMap: { default: string; [key: string]: string };
}) => textMap[value] || textMap.default;
